// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#participants-by-time-of-day-chart .apexcharts-xaxis {
  display: none;
}

#participants-by-time-of-day-chart .apexcharts-treemap rect,
.apexcharts-heatmap-series rect {
  stroke-width: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tournaments/TournamentsOverview/components/tournament-stats-styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB","sourcesContent":["#participants-by-time-of-day-chart .apexcharts-xaxis {\n  display: none;\n}\n\n#participants-by-time-of-day-chart .apexcharts-treemap rect,\n.apexcharts-heatmap-series rect {\n  stroke-width: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
